module.exports = __webpack_public_path__ + "img/ifo_logo_2.bc5159c5.png";